// dependencies
import { Map, List } from "immutable";
import { getParsedQuery } from "yarrr";

// selectors
import { getUI } from "Selectors/ui";

/** Passed as `limit` to database */
export const getPageSize = (state) => getUI(state).get("pageSize", 1);

/** Current page the user is on */
export const getCurrentPage = (state) => {
	const parsedQuery = getParsedQuery(state);
	const currentPage = parsedQuery.page ? +parsedQuery.page : 1;
	return currentPage < 1 ? 1 : currentPage;
};

/** Current value in search input */
export const getSearchInput = (state) => {
	const parsedQuery = getParsedQuery(state);
	return parsedQuery.q ? parsedQuery.q : "";
};

/**
 * Get a cached response. We cache them to ensure we are displaying the correct
 * data since server responses may not return in the same order they were
 * requested.
 */
export const getCachedResponse = (state) => {
	const query = getSearchInput(state);
	return getUI(state).getIn(["cachedResponses", query], Map());
};

/** Parse cached response */
export const getCompanies = (state) => getCachedResponse(state).get("companies", List());
export const getCompaniesCount = (state) => getCachedResponse(state).get("count", 1);

/**
 * Gets the skip count based on the current page and limit
 */
export const getSkipCount = (state) => {
	const limit = getPageSize(state);
	const currentPage = getCurrentPage(state);

	return (currentPage - 1) * limit;
};

/**
 * Calculate the page count
 */
export const getPageCount = (state) => {
	const pageSize = getPageSize(state);
	const companiesCount = getCompaniesCount(state);

	return Math.ceil(companiesCount / pageSize);
};
